export default function (array) {
  return array.length === 1 ? array[0] : array.join(' ')
}



// WEBPACK FOOTER //
// ./~/_vux@2.9.0@vux/src/filters/array2String.js